import React from 'react';

// Building blocks shared by every hospital rotation tab. Flat cards, hairline
// dividers, one section-label style; the hospital colour arrives as `accent`
// (a hex string) and is used sparingly: icons, the active segment, tints.

/** Hex colour + alpha (0–1) -> rgba string, for tinted icon tiles */
export const tint = (hex, alpha) => {
  const h = hex.replace('#', '');
  const n = parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};

/** Section label + content */
export const Section = ({ title, aside, children, className = '' }) => (
  <section className={className}>
    {title && (
      <div className="flex items-baseline justify-between mb-2 px-1">
        <h3 className="eyebrow">{title}</h3>
        {aside}
      </div>
    )}
    {children}
  </section>
);

/** A flat white card whose children stack with hairline dividers */
export const Card = ({ children, className = '' }) => (
  <div className={`bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-card overflow-hidden divide-y divide-gray-100 dark:divide-gray-700/70 ${className}`}>
    {children}
  </div>
);

/** Square icon tile tinted with the hospital colour */
export const IconTile = ({ icon: Icon, accent, size = 'md' }) => {
  const dims = size === 'lg' ? 'w-11 h-11' : 'w-9 h-9';
  return (
    <div
      className={`${dims} rounded-xl flex items-center justify-center flex-shrink-0`}
      style={{ backgroundColor: tint(accent, 0.14), color: accent }}
    >
      <Icon size={size === 'lg' ? 22 : 18} />
    </div>
  );
};

/** Muted footnote for things that aren't built yet, instead of dead rows */
export const ComingSoon = ({ items }) =>
  items?.length ? (
    <p className="px-1 text-xs text-gray-400 dark:text-gray-500">
      Coming soon: {items.join(' · ')}
    </p>
  ) : null;
